import ResourceTrigger from '@triggers/ResourceTrigger'

class BulkEditOffersTrigger extends ResourceTrigger

  @triggerConfig: ->
    computed:
      defaultTriggerName: -> 'bulk_edit'

export default BulkEditOffersTrigger
